import { render, staticRenderFns } from "./FavoriteListItem.vue?vue&type=template&id=2ef65040&scoped=true&"
import script from "./FavoriteListItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef65040",
  null
  
)

export default component.exports